import { createListenerMiddleware } from "@reduxjs/toolkit"
import type { benefitApi } from "./benefitApi"
import { benefitReadActions } from "./benefitReadSlice"
import { benefitEditorActions } from "./benefitEditorSlice"

export function createBenefitEditorListener(client: typeof benefitApi) {
  const listener = createListenerMiddleware()
  listener.startListening({ actionCreator: benefitReadActions.changed, effect: ({ payload }, api) => {
    if (payload.phase !== "current") return
    const address = { scopeKey: payload.scopeKey, benefitId: payload.id }
    const select = client.endpoints.getBenefitWorkspace.select(address)
    const query = select(api.getState() as Parameters<typeof select>[0])
    if (query.status === "fulfilled" && query.data) {
      api.dispatch(benefitEditorActions.snapshotReconciled({ ...address, readStamp: query.data.readStamp }))
    }
  } })
  return listener
}
